export enum AddType {
    NOT_ALLOWED = "notAllowed",
    QUICK = "quick",
    NORMAL = "normal"
}
